// ─── Sortable Columns ─────────────────────────────────────────────────────────

export type CustomerSortableColumn = 'companyName' | 'createdAt' | 'lastName';

// ─── User Preferences ─────────────────────────────────────────────────────────

export const CUSTOMERS_TABLE_COLUMN_ORDER_KEY = 'customers-table-column-order';
